export const ACTIVE = 'active';
export const STOPPED = 'stopped';
